
import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {AgGridReact} from 'ag-grid-react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';
// import Plot from 'react-plotly.js';

import 'ag-grid/dist/ag-grid.js';
import 'ag-grid/dist/ag-grid.min.js';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/theme-fresh.css';
import { header } from 'react-dom-factories';

//import './user.scss';

class StudentStats extends Component {
    constructor(props) {
        super(props);
        this.db = props.dbs[props.location.state.dbi].database().ref(props.institution);
        // this.props.user.uid will give you the id of the current user
        console.log("dealermode",props.location.state.dealerMode);
        this.state = {
            students: [],
            value: "",
            user: this.props.user,
            vwap: '-',
            displayStats: {},
            studentsData: [],
            lastPrice: '-',
            bid: 1,
            ask: 41,
            isSessionAdmin: true,
            sortField: null,
            sortDirection: 'asc',
            gridOptions: {
                defaultColDef: {
                    editable: false
                },
                api: {},
                columnApi: {},
                columnDefs: [
                    {
                        headerName: "#",
                        field: "id",
                        width: 75,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "User",
                        field: "user",
                        width: 175,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "Shares",
                        field: "shares",
                        width: 125,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                      headerName: "Average Position",
                      field: "avgPos",
                      width: 175,
                      filter: "agTextColumnFilter",
                      floatingFilterComponentParams: {suppressFilterButton: true},
                      suppressMenu: true
                    },
                    {
                        headerName: (props.location.state.dealerMode ? "Market Share" : "Mission"),
                        field: "mission",
                        width: 125,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "Shares Traded",
                        field: "sharesTraded",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "Percentage Limit Orders",   //"Limit:Market Order Ratio",
                        field: "lmratio",
                        width: 210,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                  /*
                   *    I kind of prefer having both, but Bruce wants this gone.      -Nate Bendich, sept 21, 2022
                    {
                        headerName: "Percentage Market Orders",   //"Limit:Market Order Ratio",
                        field: "lmratio",
                        width: 210,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                  */
                    {
                        headerName: "Max Position",
                        field: "maxsharesabsval",
                        width: 140,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "P/L",
                        field: "pl",
                        width: 125,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "BuyVWAP",
                        field: "avgbuy",
                        width: 125,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "SellVWAP",
                        field: "avgsell",
                        width: 125,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "MarketVWAP",
                        field: "marketvwap",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    }
                ],
                pagination: true,
                floatingFilter: true,
                rowData: '',
                enableSorting: true,
                onGridReady: this.onGridReady.bind(this),
                enableFilter: true
            }
        }

        this.listeners = [];
        setTimeout( ()=>{
          this.getPendingStudentsData();
        }, 600);
    }

    // Add sorting functionality
    handleSort = (field) => {
        const { sortField, sortDirection } = this.state;
        const newDirection = sortField === field && sortDirection === 'asc' ? 'desc' : 'asc';
        
        this.setState({
            sortField: field,
            sortDirection: newDirection
        }, () => {
            this.createRows();
        });
    }

    // Add filtering functionality
    handleFilter = (event) => {
        this.setState({
            filterValue: event.target.value
        }, () => {
            this.createRows();
        });
    }

    renderSortIcon(field) {
        const { sortField, sortDirection } = this.state;
        if (sortField !== field) {
            return <span style={{ marginLeft: '5px', color: '#ccc' }}>↕</span>;
        }
        return <span style={{ marginLeft: '5px', color: '#fff' }}>{sortDirection === 'asc' ? '↑' : '↓'}</span>;
    }

    handleHeaderHover = (e, isEntering) => {
        e.target.style.backgroundColor = isEntering ? '#4A5568' : '#2D3748';
    }

    convertToCSV(objArray) {
      var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      var str = '';

      for (var i = 0; i < array.length; i++) {
          var line = '';
          for (var index in array[i]) {
              if (line != '') line += ','

              line += array[i][index];
          }

          str += line + '\r\n';
      }

      return str;
  }

  exportCSVFile(headers, items, fileTitle) {
      if (headers) {
          items.unshift(headers);
      }

      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);

      var csv = this.convertToCSV(jsonObject);

      var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", exportedFilenmae);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
  }



exportTableAsCSV = () => {
  const rows = Object.values(this.state.gridOptions.rowData || {});
  if (!rows.length) {
    console.warn("No table data to export");
    return;
  }

  let headerKeys = Object.keys(rows[0]);
  const missionOrShare = this.props.location.state.dealerMode == "Market Share"
  ? "Market Share"
  : "Mission";

const headers = [
  "#",
  "User",
  "Shares",
  "Average Position",
  missionOrShare,
  "Max Position",
  "Shares Traded",
  "Percentage",
  "P/L",
  "BuyVWAP",
  "SellVWAP",
  "MarketVWAP"
];

  // Build CSV string
  const csv = [
    headers.join(","), // header row
    ...rows.map(row => headerKeys.map(field => {
      // wrap fields with quotes if they contain commas
      const val = row[field] == null ? "-" : row[field];
      return `"${String(val).replace(/"/g, '""')}"`;
    }).join(","))
  ].join("\n");

  // Create downloadable blob
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", "table_export.csv");
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


playerCSVDownload(){
    console.log('DOWNLOADING PLAYER CSV');

    if(!this.props.location.state.dealerMode){
      var headers = {
        price: 'Price'.replace(/,/g, ''), // remove commas to avoid errors
        time: "Time",
        type: "Type",
        volume: "Volume",
        user: "User"
      };

      var itemsNotFormatted = [];

      this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.user.uid).child("Transactions").once("value", ss=>{
        console.log('here 1.5')
        let tradeObj = ss.val();

        if(tradeObj === undefined || tradeObj === null){
          alert('No transactions were made!');
        }

        else {
          let tradeids = Object.keys(tradeObj);
          // let displayNameRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.user.uid).child("DisplayName");
          let displayName = this.props.user.displayName;


            tradeids.map(tradeid=>{
              console.log('Here');
              let time =  tradeObj[tradeid].Time.substring(11, 20);
              let type = tradeObj[tradeid].Type;
              let volume = tradeObj[tradeid].Volume;
              let price = tradeObj[tradeid].Price;

              itemsNotFormatted.push({ price: price, time: time, type: type, volume: volume, user: displayName});
              console.log(itemsNotFormatted);
           });




          var itemsFormatted = [];
          // format the data
          itemsNotFormatted.forEach((item) => {
            itemsFormatted.push({
                price: item.price, // remove commas to avoid errors,
                time: item.time,
                type: item.type,
                volume: item.volume,
                user: item.user
              });
            });
            var fileTitle = 'trades'; // or 'my-unique-title'
            this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
            console.log('here 2')


        }


        });
      }

      else{
          this.dealerCSVDownload(this.props.user.uid);
          return;
      }
}






  whatChanged(ref){
    let bid = false;
    let ask = false;

    let newbid = ref.order.bid;
    let newask = ref.order.ask;
    let oldbid = ref.userStats.bid;
    let oldask = ref.userStats.ask;

    if(newbid != oldbid){
      bid = true;
    }
    else{
      ask = true;
    }

    if(bid == true){
      return 'Bid';
    }
    else if(ask == true) {
      return 'Ask';
    }
  }


  detailedCSVDownload(){
    console.log('begin')

    if(!this.props.location.state.dealerMode){ //Orderbook Mode
      var headers = {
        price: 'Price'.replace(/,/g, ''), // remove commas to avoid errors
        time: "Time",
        type: "Type",
        volume: "Volume",
        user: "User"
    };

    var itemsNotFormatted = [];

    console.log('here 1')

     this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").once("value", ss=>{
       console.log('here 1.5')
       //alert(ss.val());
       let usersObj = ss.val();
       let userids = Object.keys(usersObj);

       userids.map(userid=>{
         let displayName = usersObj[userid].DisplayName;
         let tradeObj = usersObj[userid].Transactions;
         let tradeids = Object.keys(tradeObj);


       console.log("TradeObj: " + tradeObj);
       console.log("TradeIds: " + tradeids);
       console.log("TradeObj[tradeids]: " + tradeObj[tradeids]);


       tradeids.map(tradeid=>{
         console.log('Here');
         // console.log('Here 2');
         let time = tradeObj[tradeid].Time.substring(11, 20);
         let type = tradeObj[tradeid].Type;
         let volume = tradeObj[tradeid].Volume;
         let price = tradeObj[tradeid].Price;

         itemsNotFormatted.push({ price: price, time: time, type: type, volume: volume, user: displayName});
         console.log(itemsNotFormatted);
      });

    });


       var itemsFormatted = [];

    // format the data
    itemsNotFormatted.forEach((item) => {
        itemsFormatted.push({
            price: item.price, // remove commas to avoid errors,
            time: item.time,
            type: item.type,
            volume: item.volume,
            user: item.user
        });
    });

    var fileTitle = 'trades'; // or 'my-unique-title'

    this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
      console.log('here 2')
  });




    }
    else{ //DealerMode
      var headers = {
        price: 'Price'.replace(/,/g, ''), // remove commas to avoid errors
        time: "Time",
        orderClass : "Class",
        type: "Type",
        volume: "Volume",
        bestbid: "Best Bid",
        bestask: "Best Ask",
        original: "Old Price",
        newChange: "New Price",
        user: "User"
    };

     var itemsNotFormatted = [];

    console.log('here 1')

     this.db.child("Sessions").child(this.props.location.state.sessionid).child("userLogs").once("value", ss=>{


      let usersObj = ss.val();
      let userids = Object.keys(usersObj);

       userids.map(userid=>{
         let tradeObj = usersObj[userid];
         let tradeids = Object.keys(tradeObj);





       tradeids.map(tradeid=>{
         console.log('Here');

        // temporary skip until we need bot stats too
         if(tradeObj[tradeid].order.UserId.substring(0,3) === 'bot'){
           console.log('Skipped Stats. This is a bot');
         }

         else{
          let time = tradeObj[tradeid].time.substring(11, 20);
          let orderClass = tradeObj[tradeid].order.Class;
          let type = (orderClass === 'BidAskChange') ? this.whatChanged(tradeObj[tradeid]) : tradeObj[tradeid].order.Type;
          let volume;
          let price;
          let bestbid = tradeObj[tradeid].bestBid;
          let bestask = tradeObj[tradeid].bestAsk;
          let original;
          let newChange;
          let displayName = tradeObj[tradeid].userStats.displayName;

          if(orderClass === 'BidAskChange'){
            original = (type === 'Bid') ? tradeObj[tradeid].userStats.bid : tradeObj[tradeid].userStats.ask;
            newChange = (type === 'Bid') ? tradeObj[tradeid].order.Bid : tradeObj[tradeid].order.Ask;
            volume = '0';
            price = '0';
         }

         else{
           volume = (type === 'Bid') ? tradeObj[tradeid].order.Volume : -Math.abs(tradeObj[tradeid].order.Volume);
           price = (type === 'Bid') ?  tradeObj[tradeid].userStats.bid : tradeObj[tradeid].userStats.ask ;
           original = '';
           newChange = '';

         }
         itemsNotFormatted.push({ price: price, time: time, orderClass: orderClass, type: type, volume: volume, bestbid: bestbid, bestask: bestask, original: original, newChange: newChange, user: displayName});
         console.log(itemsNotFormatted);
        }
      });
    });

    var itemsFormatted = [];

    // format the data
    itemsNotFormatted.forEach((item) => {
        itemsFormatted.push({
            price: item.price, // remove commas to avoid errors,
            time: item.time,
            orderClass: item.orderClass,
            type: item.type,
            volume: item.volume,
            bestbid: item.bestbid,
            bestask: item.bestask,
            original: item.original,
            newChange : item.newChange,
            user: item.user
        });
    });

    var fileTitle = 'trades'; // or 'my-unique-title'
    this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
      console.log('here 2')
    });
  }
}


dealerCSVDownload(){
  var headers = {
    price: "Transaction Price",
    time: "Time",
    volume: "Transaction Quantity",
    user: "UserID",
    orderType: "Order Type"
  };

  const sessionRef = this.db.child("Sessions").child(this.props.location.state.sessionid);

  sessionRef.child("UsersPending").once("value", userSS => {
    let userLookup = userSS.val() || {};
    userLookup["0"] = {displayName: "Boss"};
    userLookup[0]   = {displayName: "Boss"};

    const nameOf = (uid) => {
      if (uid == null) return "Boss";
      const key = String(uid);
      return (userLookup[key] && userLookup[key].displayName) ||
             (userLookup[uid] && userLookup[uid].displayName) ||
             (String(uid).indexOf("bot") === 0 ? uid : "Boss");
    };

    sessionRef.child("Users").once("value", usersSS => {
      var items = [];
      let users = usersSS.val() || {};

      Object.keys(users).forEach(uid => {
        let trx = (users[uid] && users[uid].Transactions) || {};
        Object.keys(trx).forEach(tk => {
          let t = trx[tk];
          if (!t || t.Volume == null) return;
          items.push({
            price: +(parseFloat(t.Price) / 100).toFixed(2),
            time: t.Time,
            volume: parseInt(t.Volume, 10),
            user: nameOf(uid),
            orderType: t.Type || ""
          });
        });
      });

      items.sort((a, b) => String(a.time).localeCompare(String(b.time)));
      this.exportCSVFile(headers, items, 'dealermodeTransactions');
    });
  });
}

seriesCSVDownload(){
  if(!!this.props.location.state.dealerMode){
    return this.dealerCSVDownload();
  }

  // Keep this exact key order — it becomes the CSV column order
  var headers = {
      ask: 'Ask',
      bid: "Bid",
      price: "Transaction Price",
      time: "Time",
      volume: "Transaction Quantity",
      buyerID: "BuyerID",
      sellerID: "SellerID",
      buyerOrderType: "Buyer Order Type",
      sellerOrderType: "Seller Order Type",
      auction: "From Auction",
  };

  this.db.child("Sessions").child(this.props.location.state.sessionid).child("TimeSeries").once("value", ss=>{
   var items = [];
   let sObj = ss.val();
   this.db.child("Sessions").child(this.props.location.state.sessionid).child("UsersPending").once("value", userSS=>{
     let userLookup = userSS.val() || {};
     userLookup["0"] = {displayName: "Bot"};
     userLookup[0]   = {displayName: "Bot"};

     const nameOf = (uid) => {
       if (uid == null) return "Bot";
       const key = String(uid);
       return (userLookup[key] && userLookup[key].displayName) ||
              (userLookup[uid] && userLookup[uid].displayName) ||
              "Bot";
     };

     Object.keys(sObj || {}).forEach(ky=>{
       let pnt = sObj[ky];
       if (!pnt || !pnt.hasOwnProperty("lastOrder") || pnt.lastOrder == "-") return;

       let lOrd = JSON.parse(pnt.lastOrder);
       let oldOrder = lOrd.oldOrder;   // resting
       let newOrder = lOrd.newOrder;   // aggressive

       //let inAnAuction = (oldOrder.AuctionOnly === true) || (newOrder.AuctionOnly === true);
       let inAnAuction = oldOrder.fromAuction === true || newOrder.fromAuction === true;

       // Determine buyer vs seller from the aggressive order's Type
       let buyerOrder, sellerOrder;
       if (newOrder.Type === "Bid") {
         buyerOrder  = newOrder;
         sellerOrder = oldOrder;
       } else {
         buyerOrder  = oldOrder;
         sellerOrder = newOrder;
       }

       const strikeCents = Number(oldOrder.Strike || newOrder.Strike);
       const tradePrice = (lOrd.price != null) ? lOrd.price : (!isNaN(strikeCents) ? strikeCents / 100 : pnt.price);
       // Build the row with keys in EXACTLY the same order as `headers`
       let result = {
         ask: pnt.ask,
         bid: pnt.bid,
         price: tradePrice,
         time: pnt.time,
         volume: (lOrd.volume != null) ? lOrd.volume : Math.min(oldOrder.Volume, newOrder.Volume),
         buyerID: nameOf(buyerOrder.UserId),
         sellerID: nameOf(sellerOrder.UserId),
         buyerOrderType: buyerOrder.Class || "",
         sellerOrderType: sellerOrder.Class || "",
         auction: inAnAuction
       };

       items.push(result);
     });

     this.exportCSVFile(headers, items, 'everyTransaction');
   });
  });
}

// Graph Functions

createChartData(callback){
  let bids = [];
  let asks = [];
  let pstars = [];
  let times = [];
  var filterDates = function(tsObj){
    let theKeys = Object.keys(tsObj);
    let theDates = theKeys.map(kid=>tsObj[kid].time.substring(0,10));
    let dateSet = new Set(theDates);
    let dateArray = Array.from(dateSet);
    dateArray.sort();
    if (dateArray.length < 4){
        return {};
    }
    let findMe = dateArray[3];
    let result = {};
    theKeys.map(kid=>{
        if (tsObj[kid].time.substring(0,10) == findMe && tsObj[kid].bid > 0 && tsObj[kid].ask < 100){
            result[kid] = tsObj[kid];
        }
    });
    return result;
  }
  console.log('CREATING CHART DATA');
  if(!this.props.location.state.dealerMode){
    this.db.child("Sessions").child(this.props.location.state.sessionid).child("TimeSeries").once("value", ss=>{
      let tsObj = ss.val();
      if(tsObj === undefined || tsObj === null){
        console.log('The game has not started');
        alert('The game has not started');
      }
      else{
        tsObj = filterDates(tsObj);
        let tsids = Object.keys(tsObj);
        tsids.map(tsid=>{
          console.log('Mapping');
          let time = tsObj[tsid].time.substring(11, 19);
          let bid = (tsObj[tsid].bid);
          let ask = (tsObj[tsid].ask);
          let pstar =(tsObj[tsid].pstar || 20); // not correct

          bids.push(bid);
          asks.push(ask);
          pstars.push(pstar);
          times.push(time);
          console.log('CHART DATA CREATED');
        });

        callback(bids,asks, pstars, times);

      }

    }


    );


  }
  else{
    this.db.child("Sessions").child(this.props.location.state.sessionid).child("pstarData").once("value", ss=>{
      let tsObj = ss.val();
      if(tsObj === undefined || tsObj === null){
        console.log('The game has not started');
        alert('The game has not started');
      }
      else{
        let tsids = Object.keys(tsObj);
        tsids.map(tsid=>{
          console.log('Mapping');
          let time = tsObj[tsid].time.substring(11, 19);
          let bid = (tsObj[tsid].bid);
          let ask = (tsObj[tsid].ask);
          let pstar =(tsObj[tsid].pstar);

          bids.push(bid);
          asks.push(ask);
          pstars.push(pstar);
          times.push(time);
          console.log('CHART DATA CREATED');
        });

        callback(bids,asks, pstars, times);

      }

    });

  }


  }

  displayChart(){

    let renderChart = function (bids,asks, pstars, times){

      console.log('CREATECHARTDATA ENDS')
      console.log(bids, asks, pstars, times)

      let pstarline = {
        x: times,
        y: pstars,
        type: 'scatter',
        name: 'P*'
      };

      let testline = {
        x: [1, 2, 3, 4],
        y: [19.8, 19.8, 19.8, 19.8],
        type: 'scatter',
        name: 'Test'

      };


      let bidline = {
        x: times,
        y: bids,
        type: 'scatter',
        name: 'Bid'
      };

      let askline = {
        x: times,
        y: asks,
        type: 'scatter',
        name: 'Ask'
      };

      let data = [askline, pstarline, bidline];


      let layout = {
        title: 'P* Chart',
        xaxis: {
          title: 'Time',
          showgrid: false,
          zeroline: false
        },
        yaxis: {
          title: 'Price',
          showline: false
        }
      };

      Plotly.newPlot('chart', data, layout);

    }

    /*
    let dbtimeRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DisplayTime");
    let dbtime = JSON.stringify(dbtimeRef);
    alert(dbtime);
    */

    if(false){
      alert('Game still in session!');
    }
    else{
     this.createChartData(renderChart);
    }
  }

  // Graph Functions End ///


    registerStats(key){
      console.log("register stats", key);

      //this is outside of the if else statment as we always want the averagePos regardless of game mode.
      let avgPosRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats").child("avgPos");
      avgPosRef.on("value", ss=>{
        let data = ss.val();
        console.log("average Pos: " + data);
        if (!!data){
          let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
          console.log(displayStats);
          displayStats[key].avgPos = data;
          this.setState({displayStats});
          this.createRows();
        }
      });
      this.listeners.push(avgPosRef);

      if (!this.props.location.state.dealerMode) {
        console.log("not Dealer");
        let userStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats");
        let mRef = userStatRef.child("Mission");
        mRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].mission = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(mRef);

        let sRef = userStatRef.child("Shares");
        sRef.on("value", ss=>{
          let data = ss.val();
          console.log("test",data);
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            console.log(displayStats);
            displayStats[key].shares = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(sRef);

        let cashRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("Cash");
        cashRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].cash = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(cashRef);

        //  Shares Traded   - August 22, 2022
        //  Just takes whatever was in Firebase at this location and puts it in the post-game table
        let sharesTradedRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats").child("sharesTraded");
        sharesTradedRef.on("value", ss=>{
          let data = ss.val();
          if (!!data) {
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].sharesTraded = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(sharesTradedRef);

        //   Limit : Market Order Ratio   -written by Nathan Bendich on August 22, 2022
        let lmratioRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats").child("lmratio");
        lmratioRef.on("value", ss=>{
          let data = ss.val();
          if (!!data) {
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].lmratio = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(lmratioRef);

        //  max shares:   -written by Nathan Bendich on August 14, 2022
        let maxSharesRef = userStatRef.child("MaxShares");
        maxSharesRef.on("value", ss=>{
          let data = ss.val();
          if (!!data) {
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].maxsharesabsval = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(maxSharesRef);

        let bvwapRef = userStatRef.child("BuyVWAP");
        bvwapRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].bvwap = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(bvwapRef);
        let svwapRef = userStatRef.child("SellVWAP");
        svwapRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].svwap = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(svwapRef);
      } else {
        let userStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Dealers").child(key);
        let otherStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats");
        let svwapRef = otherStatRef.child("SellVWAP");
        let bvwapRef = otherStatRef.child("BuyVWAP");
        let svwapVal = 0;
        let bvwapVal = 0;
        svwapRef.on("value", ss=>{
            svwapVal = ss.val() || 0;
            //displayStats[key].svwap = svwapVal;//data.avgSell;
            //this.setState
            //this.createRows
        });
        bvwapRef.on("value", ss=>{
           bvwapVal = ss.val() || 0;
           //displayStats[key].bvwap = bvwapVal;//data.avgBuy;
           //etc
        });
        setTimeout(()=>{
            userStatRef.on("value", ss=>{
              let data = ss.val();
              if (!!data){
                let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
                displayStats[key].shares = data.position;
                displayStats[key].mission = data.marketShare;
                displayStats[key].cash = data.cash;
                //displayStats[key].maxsharesabsval = data.maxsharesabsval;   //avgBuy;
                displayStats[key].bvwap = bvwapVal;//data.avgBuy;
                displayStats[key].svwap = svwapVal;//data.avgSell;
                this.setState({displayStats});
                this.createRows();
              }
            });
        }, 0);//So this is silly... a poor man's Promise.All, the dealer VWAPs are bad and this is a front-end way to fix it... micro race condition that will never happen
        this.listeners.push(userStatRef);
        this.listeners.push(svwapRef);
        this.listeners.push(bvwapRef);
      }


    }

    getPendingStudentsData() {
        // this.setState({
        //     studentsData:[]
        // })
        console.log("Users Pending Loading");
        var studentRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("UsersPending");
        //this.userRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.uid).child("INTC").child("stats");
        studentRef.on('value', snap =>{
          let rawData = snap.val();
          console.log("data of student ",rawData);
          let studentInfo;
          let students = [];

          let displayStats = this.state.displayStats;
          for(var key in rawData){
            if (rawData[key].displayName){
                students.push(rawData[key]); //has .uid which == key too
                if (!displayStats.hasOwnProperty(key)){
                  console.log(key);
                  displayStats[key] = {displayName: rawData[key].displayName, mission: "-", shares: "-", avgPos: 0, maxsharesabsval: "-", sharesTraded: "-", lmratio: "-", bvwap: "-", svwap: "-", cash: "-"};
                  let that = this;
                  let uid = key;
                  setTimeout( ()=>{
                      that.registerStats(uid);
                  }, 0);
                }
            }
          }

          this.setState({
              studentsData: students,
              displayStats: displayStats
          });
          console.log("student data ", this.state.studentsData);
         // this.state.dataItemsSell = this.state.studentsDataSell.map((numbersSell) =><div>{numbersSell}</div>);
         // this.state.dataItemsBuy = this.state.studentsDataBuy.map((numbersBuy) =><li>{numbersBuy}</li>);
        })
        this.listeners.push(studentRef);
    }

    componentDidMount() {
      var vwapRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Assets").child("INTC").child("VWAP");
      var priceRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData").child("SessionData").child("lastPrice");
      var bidRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData").child("SessionData").child("bid");
      var askRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData").child("SessionData").child("ask");
      if (this.props.location.state.dealerMode){
        vwapRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DealerMarket").child("VWAP");
        priceRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DealerMarket").child("lastPrice");
      }
      vwapRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          this.setState({"vwap": data});
        }
      });
      this.listeners.push(vwapRef);

      priceRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          this.setState({"lastPrice": data});
        }
      });
      this.listeners.push(priceRef);

      bidRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          this.setState({"bid": data});
        }
      });
      this.listeners.push(bidRef);

      askRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          this.setState({"ask": data});
        }
      });
      this.listeners.push(askRef);
    }

    to1DecPlace(value){
      if (!value){
        return "-";
      } else {
        return value.toFixed(1);
      }
    }

    formatMoney(value){
      if (!value){
        return "-";
      } else {
        return value.toFixed(4);
      }
    }

    componentWillUnmount() {
        this.listeners.map(theRef=>{
          theRef.off();
        });
    }

    filterQuick(event) {
        console.log(this.state.gridOptions.rowData);
        this.state.gridOptions.api.setQuickFilter(event.target.value);

    }

    createRows() {
        let rows = [];
        for (let i = 0; i < this.state.studentsData.length; i++) {
            let student = this.state.studentsData[i];
            let stats = this.state.displayStats[student.uid];

            rows.push({
                id: i + 1,
                user: student.displayName,
                shares: stats.shares,
                avgPos: stats.avgPos.toFixed(2),
                mission: stats.mission,
                maxsharesabsval: stats.maxsharesabsval, // "maxsharesabsval" shows how risk-tolerant the student was (Bruce's idea);   August 10, 2022
                sharesTraded: stats.sharesTraded,  // Sept 27, 2022
                lmratio: this.to1DecPlace( parseFloat ( stats.lmratio)),
              // TODO : rename "lmratio" to "percentLimit"    - Sept 21, 2022
                pl: this.formatMoney(parseFloat(stats.cash) + parseFloat(stats.shares)*((parseFloat(this.state.bid) + parseFloat(this.state.ask))/2)),
                avgbuy: stats.bvwap,
                avgsell: stats.svwap,
                marketvwap: this.formatMoney(parseFloat(this.state.vwap))
            });
        }

        // Apply sorting if a sort field is selected
        if (this.state.sortField) {
            rows.sort((a, b) => {
                let aVal = a[this.state.sortField];
                let bVal = b[this.state.sortField];
                
                // Handle numeric values
                if (this.state.sortField === 'shares' || this.state.sortField === 'avgPos' || 
                    this.state.sortField === 'sharesTraded' || this.state.sortField === 'lmratio' || 
                    this.state.sortField === 'maxsharesabsval' || this.state.sortField === 'pl' || 
                    this.state.sortField === 'avgbuy' || this.state.sortField === 'avgsell' || 
                    this.state.sortField === 'marketvwap') {
                    aVal = parseFloat(aVal) || 0;
                    bVal = parseFloat(bVal) || 0;
                }
                
                // Handle string values
                if (typeof aVal === 'string') {
                    aVal = aVal.toLowerCase();
                }
                if (typeof bVal === 'string') {
                    bVal = bVal.toLowerCase();
                }
                
                if (aVal < bVal) {
                    return this.state.sortDirection === 'asc' ? -1 : 1;
                }
                if (aVal > bVal) {
                    return this.state.sortDirection === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }

        this.state.gridOptions.rowData = rows;
        this.setState(this.state);
    }

    onGridReady(params) {
        this.state.gridOptions.api = params.api;
        this.state.gridOptions.columnApi = params.columnApi;
        this.state.gridOptions.api.selectAll();
        this.setState(this.state)
    }

    render() {
        let dbi = parseInt(this.props.location.state.dbi);
        let dbObj = this.props.dbs[dbi];
        console.log(dbObj);
        let findme = "-"
        if (dbObj.hasOwnProperty("options_")){
          findme=dbObj.options_.databaseURL;
        }
        if (dbObj.hasOwnProperty("apps")){
          findme = dbObj.apps[dbi].options_.databaseURL;
        }
        let targetURL = `${findme}/${this.props.institution}/Sessions/${this.props.location.state.sessionid}/TimeSeries.json`;

        const tableStyle = {
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '20px',
            backgroundColor: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            borderRadius: '8px',
            overflow: 'hidden'
        };

        const headerStyle = {
            backgroundColor: '#2D3748',
            padding: '12px 16px',
            textAlign: 'left',
            fontWeight: 'bold',
            borderBottom: '2px solid #dee2e6',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            color: '#FFFFFF',
            userSelect: 'none'
        };

        const cellStyle = {
            padding: '12px 16px',
            borderBottom: '1px solid #dee2e6',
            verticalAlign: 'middle',
            backgroundColor: '#2D3748',
            color:  '#FFFFFF',
        };

        const rowStyle = {
            transition: 'background-color 0.2s'
        };

        const filterStyle = {
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            marginBottom: '20px',
            fontSize: '14px',
            backgroundColor: '#2D3748',
            color:  '#FFFFFF',
        };

        return (
            <div style={{ padding: '20px' }}>
                <div style={{ marginBottom: '20px' }}>
                {/* <button className='button-default' onClick={() => this.state.gridOptions.api.exportDataAsCsv()}>Export Summary Data</button> */}
                <button className='button-default' onClick={() => this.exportTableAsCSV()}>Export Summary Data</button>
                <button className='button-default' onClick={() => this.playerCSVDownload()}>Export Your Trades</button>
                <button className='button-default' onClick={() => this.seriesCSVDownload()}>Every Transaction</button>
                <button className='button-default' onClick={() => this.displayChart()}>Display Chart</button>
                </div>

                <div id='chart'></div>
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('id')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                # {this.renderSortIcon('id')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('user')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                User {this.renderSortIcon('user')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('shares')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                Shares {this.renderSortIcon('shares')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('avgPos')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                Average Position {this.renderSortIcon('avgPos')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('mission')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                {this.props.location.state.dealerMode ? 'Market Share' : 'Mission'} {this.renderSortIcon('mission')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('sharesTraded')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                Shares Traded {this.renderSortIcon('sharesTraded')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('lmratio')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                Percentage Limit Orders {this.renderSortIcon('lmratio')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('maxsharesabsval')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                Max Position {this.renderSortIcon('maxsharesabsval')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('pl')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                P/L {this.renderSortIcon('pl')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('avgbuy')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                BuyVWAP {this.renderSortIcon('avgbuy')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('avgsell')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                SellVWAP {this.renderSortIcon('avgsell')}
                            </th>
                            <th 
                                style={headerStyle}
                                onClick={() => this.handleSort('marketvwap')}
                                onMouseEnter={(e) => this.handleHeaderHover(e, true)}
                                onMouseLeave={(e) => this.handleHeaderHover(e, false)}
                            >
                                MarketVWAP {this.renderSortIcon('marketvwap')}
                            </th>
                        </tr>
                    </thead>
                <tbody>
                  {Object.values(this.state.gridOptions.rowData).map((row, index) => (
                    <tr
                      key={row.id}
                      style={{
                        ...rowStyle,
                        backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa'
                      }}
                    >
                      <td style={cellStyle}>{row.id}</td>
                      <td style={cellStyle}>{row.user}</td>
                      <td style={cellStyle}>{row.shares}</td>
                      <td style={cellStyle}>{row.avgPos}</td>
                      <td style={cellStyle}>{row.mission}</td>
                      <td style={cellStyle}>{row.sharesTraded}</td>
                      <td style={cellStyle}>{row.lmratio}</td>
                      <td style={cellStyle}>{row.maxsharesabsval}</td>
                      <td style={cellStyle}>{row.pl}</td>
                      <td style={cellStyle}>{row.avgbuy}</td>
                      <td style={cellStyle}>{row.avgsell}</td>
                      <td style={cellStyle}>{row.marketvwap}</td>
                    </tr>
                  ))}
                </tbody>
                                </table>


            </div>
        );
    }
}

export default StudentStats// counterclockwise.   (starts at bottom / bottom-left)



// WEBPACK FOOTER //
// ./src/components/Dashboard/StudentStats.js



// WEBPACK FOOTER //
// ./src/components/Dashboard/StudentStats.js